import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

/**
 * Service wrapper for UUID generation.
 * Provides consistent UUID generation across the application
 * with fallback support for environments where crypto.randomUUID is not available.
 */
@Injectable({
    providedIn: 'root'
})
export class UuidService {
    /**
     * Generates a new UUID v4.
     * Uses the uuid library which provides better browser compatibility
     * than the native crypto.randomUUID() method.
     */
    generate(): string {
        return uuidv4();
    }
    
    /**
     * Validates if a string is a valid UUID v4.
     * Useful for input validation.
     */
    isValid(uuid: string): boolean {
        const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return uuidV4Regex.test(uuid);
    }
}